import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarComment = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.5 1.5H0.5V13L4 10H13.5V1.5Z",
		stroke: "white",
		strokeLinejoin: "round"
	})]
});
export default SvgToolbarComment;
